/*
 *  -----------------------------------------------------------------------
 *    <copyright file="assign-visit.data.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { LibraryGridColumn } from '@components/admin/library-grid/library-grid.interface';
import { useGridCells } from '@hooks/index';

const { MaxLengthCell } = useGridCells();
export const ASSIGN_VISIT_TO_ASSESS_COLUMNS = (translate: Function): LibraryGridColumn[] => [
    {
        title: translate('ID'),
        id: 'item-visit-id',
        field: 'visitId',
        width: 105,
        cells: { data: MaxLengthCell(100) },
    },
    {
        title: translate('admin:type'),
        id: 'item-type',
        field: 'type',
        width: 125,
        cells: { data: MaxLengthCell(60) },
    },
    {
        title: translate('name'),
        id: 'item-name',
        field: 'visitName',
        cells: { data: MaxLengthCell(60) },
    },
];
